import * as i0 from '@angular/core';
import { EventEmitter, Directive, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/material/select';
import { fromEvent } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';

class FFSelectScrollBottomDirective {
    constructor(matSelect) {
        this.matSelect = matSelect;
        this.reachedBottom = new EventEmitter();
        this._subscription$ = this.matSelect.openedChange.pipe(filter(isOpened => isOpened), switchMap(() => fromEvent(this.matSelect.panel.nativeElement, 'scroll')), tap((event) => {
            const element = event.target;
            if (element.offsetHeight + element.scrollTop >= element.scrollHeight) {
                this.reachedBottom.emit();
            }
        })).subscribe();
    }
    ngOnDestroy() {
        this._subscription$.unsubscribe();
    }
}
FFSelectScrollBottomDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFSelectScrollBottomDirective, deps: [{ token: i1.MatSelect }], target: i0.ɵɵFactoryTarget.Directive });
FFSelectScrollBottomDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FFSelectScrollBottomDirective, selector: "[ffSelectScrollBottom]", outputs: { reachedBottom: "ffSelectScrollBottom" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFSelectScrollBottomDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ffSelectScrollBottom]'
                }]
        }], ctorParameters: function () { return [{ type: i1.MatSelect }]; }, propDecorators: { reachedBottom: [{
                type: Output,
                args: ['ffSelectScrollBottom']
            }] } });

class FFScrollingBottomModule {
}
FFScrollingBottomModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFScrollingBottomModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FFScrollingBottomModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFScrollingBottomModule, declarations: [FFSelectScrollBottomDirective], exports: [FFSelectScrollBottomDirective] });
FFScrollingBottomModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFScrollingBottomModule, providers: [], imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFScrollingBottomModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    exports: [
                        FFSelectScrollBottomDirective
                    ],
                    declarations: [
                        FFSelectScrollBottomDirective
                    ],
                    providers: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FFScrollingBottomModule, FFSelectScrollBottomDirective };
